import { useNavigate, useParams, useRouterState } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { LanguageSwitcher } from '@/features/auth/language-switcher'
import { LoginForm } from '@/features/auth/login-form'
import { getLoginRouteContext } from '@/shared/libs/admin-routes'
import { AuthHeroLayout } from '@/pages/auth/auth-hero-layout'

export function LoginPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const params = useParams({ strict: false })
  const routerState = useRouterState()
  const { tenantSlug, successPath } = getLoginRouteContext(
    routerState.location.pathname,
    params.tenantSlug,
  )

  return (
    <AuthHeroLayout>
      {/* Language switcher — top-right */}
      <div className="absolute top-4 right-4">
        <LanguageSwitcher />
      </div>

      {/* Centered login form */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <h1 className="text-2xl font-semibold text-zinc-900">{t('auth.login')}</h1>
          <p className="text-sm text-zinc-500 mt-1 mb-8">{t('auth.loginPrompt')}</p>
          <LoginForm
            tenantSlug={tenantSlug}
            onSuccess={async () => navigate({ to: successPath as never })}
          />
        </div>
      </div>
    </AuthHeroLayout>
  )
}
